import React from "react";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import { Avatar, Box, Fade, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { alpha } from "@mui/material/styles";

const SignupsPausedModal = ({ show, close }) => {
  return (
    <Dialog
      open={show}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          close(event, reason);
        }
      }}
      TransitionComponent={Fade}
      transitionDuration={400}
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
          overflow: "hidden",
          maxWidth: "500px",
          width: "100%",
          m: { xs: 1, sm: 2 },
        },
      }}
      sx={{ backdropFilter: "blur(5px)" }}
      aria-labelledby="signups-paused-modal-title"
      aria-describedby="signups-paused-modal-description"
    >
      {/* Top accent bar */}
      <Box
        sx={{
          height: 4,
          width: "100%",
          background: "linear-gradient(90deg, #61892f 0%, #4f7027 100%)",
        }}
      />

      <Box sx={{ pt: 4, pb: 2, px: { xs: 2, sm: 3 } }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Avatar
            sx={{ bgcolor: alpha("#ed6c02", 0.12), color: "#ed6c02", mr: 2 }}
          >
            <PauseCircleOutlineIcon />
          </Avatar>
          <Typography
            id="signups-paused-modal-title"
            variant="h6"
            fontWeight={700}
            color="text.primary"
            sx={{ textTransform: "uppercase", fontSize: "1rem", letterSpacing: "0.02em" }}
          >
            Join Requests Temporarily Paused
          </Typography>
        </Box>

        <Box
          sx={{
            p: 2.5,
            bgcolor: "rgba(0,0,0,0.02)",
            borderRadius: 1.5,
            border: "1px solid rgba(0,0,0,0.08)",
            mb: 3,
          }}
        >
          <Typography
            id="signups-paused-modal-description"
            variant="body2"
            sx={{ lineHeight: 1.6, color: "black", fontSize: "13px" }}
          >
            Due to an ongoing issue with GitHub, requests to join organizations
            are temporarily disabled for everyone. New joining requests will be
            enabled shortly.
          </Typography>
          <Typography
            variant="body2"
            sx={{ mt: 2, lineHeight: 1.6, color: "black", fontSize: "13px" }}
          >
            Your current access and existing memberships are <b>not</b>{" "}
            affected. There is nothing you need to do right now.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
          <Button
            variant="contained"
            onClick={close}
            sx={{
              px: 3,
              py: 1,
              bgcolor: "#4f7027",
              color: "#fff",
              fontWeight: 600,
              boxShadow: "none",
              "&:hover": { bgcolor: "#35501a" },
            }}
          >
            Got it
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default SignupsPausedModal;
